import React, { memo, useEffect } from 'react';
import { Modal, Box, Title, Group, Button, Paper, Text, Table, Space } from '@mantine/core';
import classes from '../ProducTable.module.css'
import { baseUrl } from '../../../../../../Constants/constant';
import useFetch from '../../../../../../Customhooks/useFetch';

const ViewProductRow = ({ isOpen, onClose, componentId }: any) => {
  const token = localStorage.getItem("token");

  const { data: productData, error, fetchData: getProductData } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  });

  useEffect(() => {
    if (isOpen) {
      getProductData(`${baseUrl}compute/lca/componentLca/${componentId}`);
    }
  }, [isOpen]);

  const rows = productData?.data?.rows?.map((component: any, index: number) => (
    <Table.Tr key={component.id}>
      <Table.Td>{index + 1}</Table.Td>
      <Table.Td>{component?.source_location_id}</Table.Td>
      <Table.Td>{component?.destination_location_id}</Table.Td>
      <Table.Td>{component?.Transport?.transport_name}</Table.Td>
    </Table.Tr>
  ));

  return (
    <Modal opened={isOpen} onClose={onClose} size="100%" centered withCloseButton={false}>
      <Box className="flex">
        <Title order={4}>Transport Journeys</Title>
      </Box>
      <Paper shadow="xs" className="p-4 rounded-lg">
        <Box className="mt-4">
          <Space h={'lg'} />
          {/* <Title order={5}>Transport Journies</Title> */}
          <Table striped className={classes.customtable}>
            <Table.Thead>
              <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                <Table.Th>S No.</Table.Th>
                <Table.Th>Socure Location</Table.Th>
                <Table.Th>Destination Location</Table.Th>
                <Table.Th>Transport Type</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows}
            </Table.Tbody>
          </Table>
          <Space h={'lg'} />
        </Box>
      </Paper>
        <Space h={'lg'} />
      <Group className="mt-4 justify-center">
        <Button variant="filled" color="#404040" className="w-32 rounded-lg" onClick={onClose}>
          OK
        </Button>
      </Group>
    </Modal>
  );
};

export default memo(ViewProductRow);